import React, { Component } from 'react';
const canUseDOM = !!(
  (typeof window !== 'undefined' &&
    window.document && window.document.createElement)
);

export default class ActiveChat extends Component {
  static displayName = 'ActiveChat';

  constructor(props) {
    super(props);
    const {
      appID,
    } = props;
    if (!appID || !canUseDOM) {
      return;
    }

    if (!window.activeChat) {
      window.activeChat = 1;
      const script = document.createElement('script');
      script.src = `https://app.activechat.ai/script/${appID}`;
      script.id = 'ACCW_EMBED';
      // script.setAttribute('crossorigin', '*');
      window['http://script.id'] = 'ACCW_EMBED';
      document.getElementsByTagName('head')[0].appendChild(script);
    } else {
      // window.activeChat("show");
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.customerly) return false;
    // window.activeChat("hide");
  }

  render() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/activeChat/ActiveChat.js